/**
 * LoopWorkspaceRedirect
 *
 * DEP-025: /prioritization/cascade/workbench/:cycleId/:loopId → Catchball.
 * Legacy workbench URL kept so deep links do not 404.
 */

import { Navigate, useParams } from 'react-router-dom';
import { buildCatchballInboxUrl } from '../../../lib/catchballInboxUrls';

export function LoopWorkspaceRedirect() {
  const { cycleId, loopId } = useParams<{ cycleId: string; loopId: string }>();

  if (!cycleId || !loopId) {
    return <Navigate to="/prioritization/cascade" replace />;
  }

  return <Navigate to={buildCatchballInboxUrl(cycleId, loopId)} replace />;
}

export default LoopWorkspaceRedirect;
